function Dd7Ctrl(toaster, $scope, $state, $stateParams, $rootScope, AppSettings, Dd7Service, Upload) {
  'ngInject';

  const vm = this;
  vm.orgId = $stateParams.orgId;
  console.log('DD7 Dashboard init - $stateParams.orgId:', $stateParams.orgId, '$rootScope.currentOrg:', $rootScope.currentOrg);
  vm.loading = false;
  vm.accrualRuns = [];
  vm.searchForm = {};
  vm.postingId = null;
  vm.uploadFile = null;
  vm.uploading = false;
  vm.uploadError = null;
  vm.initMonth = null;
  vm.initializing = false;
  vm.initError = null;
  vm.availableMonths = [];

  vm.init = function() {
    // Use $stateParams.orgId directly, not cached vm.orgId
    if ($stateParams.orgId) {
      vm.loadAccrualRuns();
      vm.generateAvailableMonths();
    }
  };

  // Generate list of last 12 months for initialization picker
  vm.generateAvailableMonths = function() {
    vm.availableMonths = [];
    var now = new Date();
    for (var i = 0; i < 12; i++) {
      var d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      var value = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
      var label = d.toLocaleString('default', { month: 'long', year: 'numeric' });
      vm.availableMonths.push({ value: value, label: label });
    }
  };

  vm.getMonthLabel = function(monthValue) {
    var month = vm.availableMonths.find(function(m) { return m.value === monthValue; });
    return month ? month.label : monthValue;
  };

  vm.openInitializeModal = function() {
    vm.initMonth = null;
    vm.initError = null;
    angular.element('#initializeModal').modal('show');
  };

  vm.doInitialize = function() {
    if (!vm.initMonth) return;
    
    vm.initializing = true;
    vm.initError = null;
    
    Dd7Service.initialize($stateParams.orgId, vm.initMonth, function(response) {
      vm.initializing = false;
      if (response.status === 200) {
        angular.element('#initializeModal').modal('hide');
        toaster.pop('success', 'Fetch Started', response.data.message || 'Fetching historical data. Check notifications for results.');
        // Refresh the list after a short delay
        setTimeout(function() { vm.loadAccrualRuns(); }, 2000);
      } else {
        vm.initError = response.data.error || 'Failed to start historical fetch';
      }
    });
  };

  vm.loadAccrualRuns = function() {
    vm.loading = true;
    Dd7Service.getAccrualRuns($stateParams.orgId, vm.searchForm, function(response) {
      vm.loading = false;
      if (response.status == 200) {
        vm.accrualRuns = response.data.accrual_runs || [];
      } else {
        toaster.pop('error', 'Error', 'Failed to load accrual runs');
      }
    });
  };

  vm.search = function() {
    vm.loadAccrualRuns();
  };

  vm.resetSearch = function() {
    vm.searchForm = {};
    vm.loadAccrualRuns();
  };

  vm.postToXero = function(run) {
    vm.postingId = run.id;
    Dd7Service.postToXero($stateParams.orgId, run.id, function(response) {
      vm.postingId = null;
      if (response.status == 200) {
        toaster.pop('success', 'Success', response.data.message || 'Posted to Xero');
        vm.loadAccrualRuns();
      } else {
        toaster.pop('error', 'Error', response.data.error || 'Failed to post');
      }
    });
  };

  vm.viewDetail = function(run) {
    var currentOrgId = $stateParams.orgId || $state.params.orgId;
    $state.go('user.organization.dashboard.dd7.detail', { orgId: currentOrgId, runId: run.id }, { inherit: false });
  };

  vm.openUploadModal = function() {
    vm.uploadFile = null;
    vm.uploadError = null;
    angular.element('#uploadModal').modal('show');
  };

  vm.doUpload = function() {
    if (!vm.uploadFile) return;
    
    vm.uploading = true;
    vm.uploadError = null;
    
    Dd7Service.upload($stateParams.orgId, vm.uploadFile, function(response) {
      vm.uploading = false;
      if (response.status == 200) {
        angular.element('#uploadModal').modal('hide');
        toaster.pop('success', 'Success', response.data.message || 'Upload processed');
        vm.loadAccrualRuns();
      } else {
        vm.uploadError = response.data.error || 'Upload failed';
        if (response.data.months) {
          vm.uploadError += ' Months found: ' + response.data.months.join(', ');
        }
      }
    });
  };

  vm.downloadRawData = function(run) {
    // TODO: Implement download
    toaster.pop('info', 'Info', 'Download not yet implemented');
  };

  vm.retry = function(run) {
    vm.retryingId = run.id;
    Dd7Service.retry($stateParams.orgId, run.id, function(response) {
      vm.retryingId = null;
      if (response.status === 200) {
        toaster.pop('success', 'Success', response.data.message || 'Retry complete');
        vm.loadAccrualRuns();
      } else {
        toaster.pop('error', 'Error', response.data.error || 'Retry failed');
        vm.loadAccrualRuns();
      }
    });
  };

  vm.fetchFromAmazon = function() {
    vm.fetching = true;
    // Default to last 60 days to catch monthly deferred transactions
    var params = {
      start_date: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
      end_date: new Date().toISOString()
    };
    
    Dd7Service.fetchFromAmazon($stateParams.orgId, params, function(response) {
      vm.fetching = false;
      if (response.status === 200) {
        toaster.pop('success', 'Fetch Queued', response.data.message || 'Fetching deferred transactions from Amazon. You will be notified when complete.');
      } else {
        toaster.pop('error', 'Error', response.data.error || 'Failed to start fetch');
      }
    });
  };

  vm.getStatusClass = function(status) {
    switch(status) {
      case 'done': return 'label-success';
      case 'ready': return 'label-info';
      case 'pending': return 'label-warning';
      case 'mapping': return 'label-danger';
      case 'error': return 'label-danger';
      default: return 'label-default';
    }
  };

  vm.formatCurrency = function(amount) {
    if (amount === null || amount === undefined) return '-';
    var num = parseFloat(amount);
    var prefix = num < 0 ? '-$' : '$';
    return prefix + Math.abs(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  // Initialize on load
  vm.init();
}

Dd7Ctrl.$inject = ['toaster', '$scope', '$state', '$stateParams', '$rootScope', 'AppSettings', 'Dd7Service', 'Upload'];

export default {
  name: 'Dd7Ctrl',
  fn: Dd7Ctrl
};
